const nodePath = new URL('../../icons/node-path.png', import.meta.url).href

export default {
  type: 'NodePath',
  description: 'node path',
  icon: nodePath,
  group: ['etc'],
  model: {
    type: 'NodePath',
    left: 100,
    top: 100,
    width: 20,
    height: 20,
    fillStyle: '#fff',
    strokeStyle: 'rgb(0, 0, 0, 0.2)',
    alpha: 0.2,
    lineWidth: 12,
    lineDash: 'solid',
    lineCap: 'round',
    joinStyle: 'round',
    nodes: [
      {
        id: '1',
        position: { x: 100, y: 100 },
        name: 'Node 1',
        connections: ['2']
      },
      {
        id: '2',
        position: { x: 200, y: 100 },
        name: 'Node 2',
        connections: ['3']
      },
      {
        id: '3',
        position: { x: 200, y: 200 },
        name: 'Node 2',
        connections: ['4']
      },
      {
        id: '4',
        position: { x: 100, y: 200 },
        name: 'Node 2',
        connections: []
      }
    ]
  }
}
